/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceResolvedPermission
 */
export interface WorkspaceResolvedPermission {
    /**
     * 
     * @type {number}
     * @memberof WorkspaceResolvedPermission
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceResolvedPermission
     */
    readOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceResolvedPermission
     */
    workspace: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceResolvedPermission
     */
    user?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceResolvedPermission
     */
    group?: number | null;
}

export function WorkspaceResolvedPermissionFromJSON(json: any): WorkspaceResolvedPermission {
    return WorkspaceResolvedPermissionFromJSONTyped(json, false);
}

export function WorkspaceResolvedPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceResolvedPermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'readOnly': !exists(json, 'read_only') ? undefined : json['read_only'],
        'workspace': json['workspace'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'group': !exists(json, 'group') ? undefined : json['group'],
    };
}

export function WorkspaceResolvedPermissionToJSON(value?: WorkspaceResolvedPermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'read_only': value.readOnly,
        'workspace': value.workspace,
        'user': value.user,
        'group': value.group,
    };
}


